/**
 * customHardSet is a state reconciler based on hardSet from redux-persist which simply returns the inbound state as is.
 * It's main purpose is to allow a hard and fast shallow state reconciler which also strips out any persisted blacklist items
 * such as authToken. This is necessary to a bug with blacklisting keys which will change AFTER the persist happens.
 * Bug for blacklists: https://github.com/rt2zz/redux-persist/issues/518
 * State Reconciler signature https://github.com/rt2zz/redux-persist/blob/master/docs/api.md#type-statereconciler
 *
 * @param {object} inboundState -     The state being rehydrated from storage
 * @param {object} originalState -    The state before the REHYDRATE action
 * @param {object} reducedState -     The store state after the REHYDRATE action but before the reconcilliation into final "rehydrated" state
 * @param {object} config -           a persist config object: https://github.com/rt2zz/redux-persist/blob/master/docs/api.md#type-persistconfig
 */
export default function customHardSet(inboundState, originalState, reducedState, config) {
  if (config.blacklist) {
    for (var index = 0; index < config.blacklist.length; index += 1) {
      var key = config.blacklist[index];
      config.storage.removeItem(key);
    }
  }
  return inboundState;
}